import React from 'react';

import '../styles/auth.css';

interface ModalContentProps {
  children: React.ReactNode;
  onClose?: () => void;
  className?: string;
}

export const ModalContent: React.FC<ModalContentProps> = ({
  children,
  onClose: _onClose,
  className,
}) => (
  <div
    className={`auth-modal-content ${className || ''}`}
    role="dialog"
    aria-modal="true"
    onClick={(e) => e.stopPropagation()} // Prevent clicks inside from closing modal
  >
    {children}
  </div>
);
